<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { TooltipRootEmits, TooltipRootProps } from 'reka-ui'

import { cn } from 'cn'
import { omit } from 'radashi'
import { TooltipRoot, useForwardPropsEmits } from 'reka-ui'

const props = defineProps<TooltipRootProps & { openOnClick?: boolean, class?: HTMLAttributes['class'] }>()
const emits = defineEmits<TooltipRootEmits>()

const forwarded = useForwardPropsEmits(() => omit(props, ['openOnClick']), emits)
const isOpen = ref(props.open === undefined ? false : props.open)

const openTooltip = () => { // workaround for https://github.com/unovue/reka-ui/issues/1443
  if (!isOpen.value)
    isOpen.value = !isOpen.value
}
</script>

<template>
  <TooltipRoot
    v-bind="forwarded"
    v-model:open="isOpen"
    :disable-closing-trigger="openOnClick || disableClosingTrigger"
  >
    <span
      v-if="openOnClick"
      :class="cn('inline-flex items-center leading-none', props.class)"
      @click="openTooltip"
    >
      <slot />
    </span>
    <slot v-else />
  </TooltipRoot>
</template>
